import {
  Badge,
  Link,
  List,
  ListItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import React from "react";

const schedule = (data, activeWeek, superActiveWeek) => (
  <div className="schedule" id="scheduleTable">
    <TableContainer className="table-container">
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            {(data.columns[0].column||[]).map((column) => (
              <TableCell
                key={column.label[0]}
                align={"center"}
                style={{ minWidth: parseInt(column.minWidth[0], 10) }}
              >
                {column.label[0]}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {(data.rows[0].row||[]).map((row) => {
            if (row.divider) {
              return (
                <TableRow key={row.title[0]}>
                  <TableCell colSpan={data.n[0]}>
                    <h3>{row.title[0]}</h3>
                  </TableCell>
                </TableRow>
              );
            }
            return (
              <TableRow hover role="checkbox" tabIndex={-1} key={row.week[0]}>
                {(data.columns[0].column||[]).map((column, idx) => {
                  const value = row[String(column.label[0]||"").toLowerCase()][0];
                  return (
                    <TableCell key={column.label[0]} align={column.align[0]||'justify'}>
                      {(value instanceof Object) && (
                        <List>
                          {(value.item || []).map((d) => {
                            let text = "";
                            let link = "";
                            if(d['_']){
                              text = d['_'];
                              link = d['$']?d['$'].url:'';
                            }
                            else{
                              text = d;
                            }
                            if (!text) {
                              return null;
                            }
                            return (
                              <ListItem key={text}>
                                {link && (
                                  <Link
                                    href={link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {text}
                                  </Link>
                                )}
                                {!link && <bdi>{text}</bdi>}
                              </ListItem>
                            );
                          })}
                        </List>
                      )}
                      {!Array.isArray(value) && idx === 0 && (
                        <Badge
                          className="doneWeeks"
                          badgeContent={value}
                          color="secondary"
                        >
                          <Typography>
                            <i
                              className="fa fa-circle-notch fa-lg"
                              style={{ color: "#2b2b2b" }}
                            />
                          </Typography>
                        </Badge>
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  </div>
);

export default function Schedule({ data }) {
  return (
    <div id="schedule">
      <Paper className="bg">{schedule(data.schedule[0])}</Paper>
    </div>
  );
}
